module.exports = __webpack_public_path__ + "img/new_index_cases1.dffefa6b.jpg";